module.exports = __webpack_public_path__ + "static/media/pic5.a79eaa4c.jpg";